import React, { Component } from "react";
import { Col, Row, Button } from "react-bootstrap";
import { saveAs } from "file-saver";
import { connect } from "react-redux";

import WebCam from "../../components/WebCam";
import LongMenu from "../../components/menu";
import FileDropZone from "../../components/fileDropZone";
import WebCamBttn from "../asset_components/webCamBttn";
import UploadBttn from "../asset_components/uploadBttn";
import Settings from "./settings";

/* assests imports */
import settingIcon from "../../assets/icons/settings.svg";
import edit from "../../assets/icons/edit.svg";
import deleteIcon from "../../assets/icons/x.svg";
import MapCaputeredImg from "../commonComponents/MapCapturedImg";

var JSZip = require("jszip");
var JSZipUtils = require("jszip-utils/dist/jszip-utils");

class ImportData_a extends Component {
  previewCanvasArr = []; //Imported file can be accessed from this array
  trainingCanvasArr = [];
  localCamStatus = false;
  imgHTMLArray = null;
  pointEv = "visible";
  classOp = 1;
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: [],
      className: "Class Name 1",
      webCamStatus: false, //to activate or deactivate webcam
      classStatus: true,
      uploadClicked: false,
      settingsStatus: false,
    };
  }

  handleCloudImport = () => {};

  //delete redered images
  deleteImage = (id) => {
    this.previewCanvasArr.splice(id, 1);
    this.trainingCanvasArr.splice(id, 1);
    this.setState({
      selectedFile: this.previewCanvasArr,
    });
  };

  //enable webcam
  handleWebCam = () => {
    if (this.state.uploadClicked) {
      this.setState({
        uploadClicked: false,
      });
    }
    this.localCamStatus = true;
    this.props.stopGlobalCam(true, this.props.keyId);
  };

  updateUploadClick = () => {
    if (this.props.globalCam) {
      this.localCamStatus = false;
      this.props.stopGlobalCam(false);
    }
    this.setState({
      uploadClicked: true,
    });
  };

  //disable webcam
  closeWebCam = () => {
    this.localCamStatus = false;
    this.props.stopGlobalCam(false);
  };

  closeUploadParent = () => {
    this.setState({
      uploadClicked: false,
    });
  };

  enableEditClassName = () => {
    if (this.state.classStatus) {
      document.getElementById("in" + this.props.keyId).style.opacity = 0.5;
      document.getElementById("in" + this.props.keyId).focus();
    }
  };

  handleSettings = () => {/* 
    if (this.state.settingsStatus) {
      this.setState({
        settingsStatus: false,
      });
      this.localCamStatus = true;
      this.props.stopGlobalCam(true, this.props.keyId);
    } else {
      this.setState({
        settingsStatus: true,
        uploadClicked: false,
      });
      this.localCamStatus = false;
      this.props.stopGlobalCam(false);
    } */
  };

  //to access captures image src from WebCam.js
  callbackFunction = (previewCanvas, trainingCanvas) => {
    this.previewCanvasArr.push(previewCanvas);
    this.trainingCanvasArr.push(trainingCanvas);
    this.setState({
      selectedFile: this.previewCanvasArr,
    });
  };

  //disable or enable class
  disableClass = () => {
    if (this.state.classStatus) {
      this.setState({
        classStatus: false,
      });
      this.classOp = 0.5;
      this.pointEv = "none";
    } else {
      this.setState({
        classStatus: true,
      });
      this.classOp = 1;
      this.pointEv = "visible";
    }
  };

  //training model also converts img to tensors
  //LEAERNING
  trainModel = () => {
    this.props.preceiveTensors(this.trainingCanvasArr, this.state.className);
  };

  //get data from child components. holds array of images
  getFromChild = (previewCanvas, trainingCanvas) => {
    this.previewCanvasArr.push(previewCanvas);
    this.trainingCanvasArr.push(trainingCanvas);
    this.setState({
      selectedFile: this.previewCanvasArr,
    });
  };

  deleteClass = () => {
    this.props.preceiveSignal(this.props.keyId);
  };

  //handle classname text
  editClassName = (e) => {
    document.getElementById("in" + this.props.keyId).style.opacity = 1;
    this.setState({
      className: e.target.value,
    });
  };

  //Funtion to download samples.
  downloadSamples = () => {
    let zip = new JSZip();
    let count = 0;
    let zipFilename = "alpha_ml.zip";
    function urlToPromise(url) {
      return new Promise(function (resolve, reject) {
        JSZipUtils.getBinaryContent(url, function (err, data) {
          if (err) {
            throw err;
          } else {
            resolve(data);
          }
        });
      });
    }

    this.trainingCanvasArr.map((canvas) => {
      let filename = "file_" + count + ".png";
      let url = canvas.toDataURL("image/png", 1.0);
      zip.file(filename, urlToPromise(url), { binary: true });
      count++;
      if (count === this.previewCanvasArr.length) {
        zip.generateAsync({ type: "blob" }).then(function callback(blob) {
          saveAs(blob, zipFilename);
        });
      }
    }, this);
  };

  componentWillMount() {
    if (this.props.globalCam) {
      this.props.stopGlobalCam(false);
    }
    this.setState({
      className: "Sample " + this.props.classCount,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.keyId !== nextProps.gclassID) {
      this.localCamStatus = false;
    }
  }

  render() {
    let dispWebCam,
      importEnabled,
      importDisabled,
      buttonType,
      closeCam,
      dispImages,
      settingsIcon,
      settingsDisp;
    if (this.previewCanvasArr.length > 0) {
      dispImages = (
        <MapCaputeredImg
          imgUrl={this.previewCanvasArr}
          childDeleteImg={this.deleteImage}
          pKeyId={this.props.keyId}
        />
      );
    }
    if (
      this.props.convertSignal &&
      this.state.classStatus
    ) {
      this.trainModel();
    }
    if (this.localCamStatus) {
      dispWebCam = (
        <WebCam
          parentCallBack={this.callbackFunction}
          capture={true}
          id={this.props.keyId}
        />
      );
      buttonType = (
        <Button
          style={{
            padding: "0px",
            border: "0px",
            outline: "none",
            borderRadius: "7px",
          }}
          onClick={this.updateUploadClick}
        >
          <UploadBttn />
        </Button>
      );
      settingsIcon = (
        <img src={settingIcon} alt='settings' onClick={this.handleSettings}></img>
      );
      closeCam = (
        <div
          style={{
            marginLeft: "275px",
            position: "absolute",
            zIndex: "1",
          }}
        >
          <img
            onClick={this.closeWebCam}
            style={{ height: "20px", width: "20px" }}
            src={deleteIcon}
            alt='delete'
          />
        </div>
      );
    } else {
      dispWebCam = (
        <FileDropZone
          dndCall={this.getFromChild.bind(this)}
          closeUpload={this.closeUploadParent}
        />
      );
      buttonType = (
        <Button
          style={{
            padding: "0px",
            border: "0px",
            outline: "none",
            borderRadius: "7px",
          }}
          onClick={this.handleWebCam.bind(this)}
        >
          <WebCamBttn />
        </Button>
      );
    }
    if (this.state.uploadClicked || this.localCamStatus) {
      importEnabled = (
        <div>
          {closeCam}
          {/* {localImp} */}
          {dispWebCam}
          <Row>
            <div
              style={{
                color: "#C2C0BD",
                marginTop: "32px",
                marginLeft: "30px",
              }}
            >
              <Col xs={1} style={{ paddingTop: "7px" }}>
                or
              </Col>
              <Col xs={5}>{buttonType}</Col>
              <Col xs={5} style={{ paddingTop: "7px", paddingLeft: "25px" }}>
                {settingsIcon}
              </Col>
            </div>
          </Row>

          <Row>
            <MapCaputeredImg
              imgUrl={this.previewCanvasArr}
              childDeleteImg={this.deleteImage}
              pKeyId={this.props.keyId}
            />
          </Row>
        </div>
      );
    } else if (this.state.settingsStatus) {
      settingsDisp = (
        <Settings handleSettingsProps={this.handleSettings.bind(this)} />
      );
    } else {
      importDisabled = (
        <div>
          <div
            style={{
              fontSize: "12px",
              color: "#C2C0BD",
              marginRight: "30px",
              marginTop: "5px",
              marginLeft: "30px",
              height: "30px",
              width: "70px",
            }}
          >
            <p style={{ paddingTop: "15px" }}>Add sample:</p>
          </div>
          <Row>
            <div
              style={{
                marginTop: "15px",
                marginLeft: "25px",
                marginRight: "30px",
              }}
            >
              <Col xs={6}>
                <Button
                  onClick={this.updateUploadClick}
                  style={{
                    padding: "0px",
                    border: "0px",
                    outline: "none",
                    borderRadius: "7px",
                  }}
                >
                  <UploadBttn />
                </Button>
              </Col>
              <Col xs={6}>
                <Button
                  style={{
                    padding: "0px",
                    border: "0px",
                    outline: "none",
                    borderRadius: "7px",
                  }}
                  onClick={this.handleWebCam.bind(this)}
                >
                  <WebCamBttn />
                </Button>
              </Col>
            </div>
          </Row>
          <Row>{dispImages}</Row>
        </div>
      );
    }
    return (
      <div
        style={{
          marginTop: "90px",
          borderWidth: "1px",
          borderStyle: "solid",
          background: "#2E3A53",
          width: "375px",
          boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
          borderRadius: "9px",
          pointerEvents: this.pointEv,
          opacity: this.classOp,
        }}
      >
        <div>
          {settingsDisp}
          {importEnabled}
          {importDisabled}
        </div>
        <div>
          <p
            style={{
              width: "323px",
              height: "0px",
              marginLeft: "26px",
              marginTop: "10px",
              color: "#C2C0BD",
              borderStyle: "solid",
              borderWidth: "0.5px",
            }}
          />
        </div>
        <Row>
          <div
            style={{
              color: "#C2C0BD",
              marginTop: "12px",
              marginLeft: "30px",
              marginBottom: "50px",
            }}
          >
            <Col xs={3} md={3} lg={3}>
              <input
                style={{
                  marginTop: "2px",
                  borderWidth: "0px",
                  background: "#2E3A53",
                  color: "#C2C0BD",
                  outline: "none",
                  width: "100px",
                  fontFamily: "Helvetica",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
                id={"in" + this.props.keyId}
                type="text"
                //placeholder={"Sample " + this.props.classCount}
                placeholder={this.state.className}
                class="txt_input"
                onChange={this.editClassName}
              />
            </Col>
            <Col xs={6} md={6} lg={6}>
              <img src={edit} alt='edit' onClick={this.enableEditClassName} />
            </Col>
            <Col xs={3} md={3} lg={3}>
              <div style={{ pointerEvents: "visible" }}>
                <LongMenu
                  parentDownload={this.downloadSamples.bind(this)}
                  parentDisable={this.disableClass.bind(this)}
                  parentDelete={this.deleteClass.bind(this)}
                />
              </div>
            </Col>
          </div>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    convertSignal: state.convertSignal,
    globalCam: state.globalCam,
    gclassID: state.gclassID,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //DISABLE CAM ON MOUNT
    stopGlobalCam: (gCam, classID) => {
      dispatch({
        type: "GLOBAL_CAM",
        gCam: gCam,
        classID: classID,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportData_a);
